/*
* @Author: babysoft08
* @Date:   2025-03-01 18:16:22
* @Last Modified by:   abhishek714
* @Last Modified time: 2025-03-24 14:43:24
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import $ from 'jquery';
import Loader from './../../components/Loader/Loader';
import GearSpinner from './../../components/GearSpinner/GearSpinner';
import UserService from './../../services/UserService/UserService';
import { Validation } from '../../validation';
import stepCheckIcon from '../../images/step-check-icon.png';
import adminUserIcon from '../../images/admin-user-img.png';
import associateUserIcon from '../../images/associate-img.png';
import continueBtn from '../../images/continue-btn.png';
import thankYouImg from '../../images/thank-you-txt-img.png';
import uploadImg1 from '../../images/upload-img1.png';
import logo from '../../images/techtop-full-logo.svg';

class SignUp extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentStep : 1,
			steps : ["Your Role", "Personal & Account Details", "All Set"],
			fields: {
				user_role: 'associate',
				company_logo_file :''
			},
            errors: {},
            error_message:'',
            signup_error_message:'',
            user_data: {},
            associate_data: {},
            is_login:0,
            is_logout:0,
            success_redirect:0,
            isLoading:0,
            isSpin:0,
            company_logo:uploadImg1,
            invitation_token:'',
            is_show_company_logo:true,
            is_show_upload : true
        }
		
		this.updateProgressBar = this.updateProgressBar.bind(this);
		this.nextStep = this.nextStep.bind(this);
		this.prevStep = this.prevStep.bind(this);
		this.goToStep = this.goToStep.bind(this);
		this.renderProgressHtml = this.renderProgressHtml.bind(this);
		this.renderStep1Html = this.renderStep1Html.bind(this);
		this.renderStep2Html = this.renderStep2Html.bind(this);
		this.renderStep3Html = this.renderStep3Html.bind(this);
		this.renderStepContent = this.renderStepContent.bind(this);
		this.submitForm = this.submitForm.bind(this);
		this.successRedirect = this.successRedirect.bind(this);
		this.renderSignupError = this.renderSignupError.bind(this);
		this.renderHtmlContent = this.renderHtmlContent.bind(this);
		this.renderFormHtml = this.renderFormHtml.bind(this);
		this.userService = new UserService();
	}

	componentDidMount() {
		let { fields, company_logo } = this.state;
		const invitation_token = this.props.match.params.invitation_token;
		if(invitation_token) {
			this.setState({ invitation_token : invitation_token, isSpin : 1 });
			const data = {"invitation_token":invitation_token};
			this.userService.getInvitationData(data).then(response => {
				this.setState({  isSpin : 0, is_show_company_logo : true });
				if(response.data.response === 'success') {
					if(Object.keys(response.data.result.associate_data).length > 0) {
						if(response.data.result.associate_data.company_logo !== '') {
							company_logo = response.data.result.associate_data.company_logo;
						} else {
							this.setState({ is_show_upload : true });
						}
					}
					this.setState({
						currentStep : 2,
						fields : {
							...fields,
							id: response.data.result.user_data.id,
							user_role: response.data.result.user_data.user_role,
							first_name: response.data.result.user_data.first_name,
							last_name: response.data.result.user_data.last_name,
							email: response.data.result.user_data.email,
							company: response.data.result.associate_data.company,
							associate_with: response.data.result.associate_data.id  
						},
						user_data : response.data.result.user_data,
						associate_data : response.data.result.associate_data,
						isCompanyReadOnly:1,
						isEmailReadOnly:1,
						company_logo: company_logo
					});
				}
			});
		}
	}

	updateProgressBar() {
		return ((this.state.currentStep - 1) / 2) * 100;
	}

	nextStep() {
		if (this.state.currentStep < 3) {
			this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }));
		}
	};

	prevStep() {
		if (this.state.currentStep > 1) {
			this.setState((prevState) => ({ currentStep: prevState.currentStep - 1 }));
		}
	};

	goToStep = (step) => {
		const { currentStep } = this.state;
		if (
	      (currentStep === 1 && step !== 1) || 
	      (currentStep === 2 && step === 3) || 
	      (currentStep === 3 && step !== 3)
	    ) {
	      return; // Restrict navigation based on conditions
	    }
	    this.setState({ currentStep: step });
	}

	successRedirect() {
    	if(this.state.success_redirect===1) {
    		return <Redirect to="/" />
    	}
    }

    handleSubmit(e) {
	    e.preventDefault();
	    const { fields } = this.state;
	    let validationFields = ['first_name', 'last_name', 'company', 'address', 'phone', 'email', 'password', 'confirm_password'];

	    let errors = Validation(fields, validationFields);
	    if (Object.keys(errors).length > 0) {
	        this.setState({ errors: errors });
	        return;
	    }

	    this.submitForm(e);
	}

	submitForm(e) {
		e.preventDefault();
		$("#btnSignUp").attr("disabled", true);
		this.setState({ signup_error_message: "" });
		const data = {
		    ...this.state.fields,
		    encrypted_password: this.state.fields.password,
		    company_logo: this.state.fields.company_logo_file
		};
		delete data.password;
		delete data.company_logo_file;
		this.setState({ isLoading : 1});
		this.userService.newSignUp(data).then(response=>{
        	$("#btnSignUp").attr("disabled", false);
        	this.setState({error_message:'', isLoading : 0 });
        	if(response.status===200) {
        		if(response.data.response==='fail') {
        			this.setState({signup_error_message:response.data.message});
        			window.scrollTo({ top: 0, behavior: "smooth" });
        		} else{
        			this.setState({ isLoading : 0});
        			this.nextStep();
        		}
        	}
        });
		
	}

	handleChange(field, e){
		let { fields, errors } = this.state; 
		const { name, value } = e.target;
        const newFormData = {
            ...fields,
            [name]: value,
        };
        errors = {
        	...errors,
        	[name]:''
        };
        this.setState({fields : newFormData, errors : errors, signup_error_message : '' });
	}

	handleClick(e) {
	    const { name, value } = e.target;
	    this.setState((prevState) => ({
	        fields: {
	            ...prevState.fields,
	            [name]: value,
	        },
	    }));
	}

	handleLogoChange(e) {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.setState({
				    company_logo: e.target.result, // Display the image preview
				    fields: {
				        ...this.state.fields, // Keep other fields unchanged
				        company_logo_file: file // Update only the company_logo_file field
				    }
				});
            };
            reader.readAsDataURL(file); // Convert the image to base64 for preview
        }
    }

	renderProgressHtml() {
		const { steps, invitation_token } = this.state;
		let { currentStep } = this.state;
		return (
			<React.Fragment>
				{this.renderSignupError()}
				<div className="row">
					<div className="col-md-10 offset-md-1 width-sm">
						<div className="progress px-1" style={{ height: "2px" }}>
							<div className="progress-bar" role="progressbar" style={{ width: `${this.updateProgressBar()}%` }} aria-valuenow={this.updateProgressBar()} aria-valuemin="0" aria-valuemax="100">
							</div>
						</div>
						<div className="step-container d-flex justify-content-between">
							{
								steps.map((text, index) => (
									<div
										key={index}
										className={`step-circle ${currentStep > index + 1 ? "completed" : ""}`} 
										onClick={() => {
											if (!invitation_token) {
												this.goToStep(index + 1);
											}
										}}
									>
										{
											(currentStep > index + 1 || currentStep === steps.length) && <img src={stepCheckIcon} className="img-fluid step-check-img" alt="Checked" />
										}
										<p>{text}</p>
									</div>
								))
							}
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	};

	renderStep1Html() {
		let { currentStep } = this.state;
		return(
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">
						<h3 className="mb-4">Welcome! Choose Your Role to Get Started.</h3>
					</div>
					<div className="col-md-10 offset-md-1">		
						<div className="table-responsive">
							<table className="table table-bordered" id="techtop-role-form">
								<thead>
									<tr>
										<th></th>
										<th style={{width: "195px"}}>Role Type</th>
										<th>Description</th>
										<th>Access Details</th>
									</tr>
								</thead>
								<tbody>
									<tr>	
										<td>
											<div className="form-check">
												<input className="form-check-input on" type="radio" name="user_role" value="admin" id="user_role_admin" checked={this.state.fields.user_role === "admin"} onChange={this.handleClick.bind(this)}  />
												<label className="form-check-label" htmlFor="user_role_admin"></label>
											</div>
										</td>
										<td>
											<img src={adminUserIcon} className="img-fluid circle-img" htmlFor="user_role_admin"/> <strong>Admin User</strong>
										</td>
										<td>Account Owner has full access </td>
										<td>
											<ul>
												<li>Associate access permissions</li>
												<li>Open Orders</li>
												<li>Order History</li>
												<li>Upload PO’s</li>
												<li>Net Pricing</li>
											</ul>
										</td>
									</tr>
									<tr>	
										<td>
											<div className="form-check">
												<input className="form-check-input off" type="radio" name="user_role" value="associate" id="user_role_associate" checked checked={this.state.fields.user_role === "associate"} onChange={this.handleClick.bind(this)}  />
												<label className="form-check-label" htmlFor="user_role_associate"></label>
											</div>
										</td>
										<td>
											<img src={associateUserIcon}  className="img-fluid circle-img" htmlFor="user_role_associate"/> <strong>Associate</strong>
										</td>
										<td>Work associate to the account Owner has limited access.</td>
										<td>
											<ul>
												<li>Open Orders **</li>
												<li>Order History **</li>
												<li>Upload PO’s </li>
												<li>Net Pricing **</li>
											</ul>
											<p className="text-center">**Access can be adjusted or removed at any time by Admin User</p>
										</td>
									</tr>
								</tbody>	
							</table>	
						</div>	
					</div>
					<div className="col-md-12">
						<div className="col-md-12">
							<button type="button" className="next-step" onClick={this.nextStep}>
								<img src={continueBtn} className="img-fluid" alt="Continue"/>
							</button>
						</div>
					</div>
				</div>	
			</React.Fragment>
		)
	}

	renderAdminSignupForm() {
		let { currentStep, fields, errors, isEmailReadOnly, isCompanyReadOnly } = this.state;
		return(
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">	
						<p>In order to create your account please provide the information below</p>
						<div className="row">
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="first_name" className="form-label">First Name:</label>
									<input type="text" className="form-control" name="first_name" placeholder="First Name" ref="first_name" id="first_name" onChange={this.handleChange.bind(this, "first_name")} defaultValue={this.state.fields["first_name"]}/>
									{errors.first_name && <div className="text-danger">{errors.first_name}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="middle_initial" className="form-label">Middle Name:</label>
									<input type="text" className="form-control" name="middle_initial" placeholder="Middle Name" id="middle_initial" ref="middle_initial" onChange={this.handleChange.bind(this, "middle_initial")} defaultValue={this.state.fields["middle_initial"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="last_name" className="form-label">Last Name:</label>
									<input type="text" className="form-control" name="last_name" placeholder="Last Name" ref="last_name" id="last_name" onChange={this.handleChange.bind(this, "last_name")} defaultValue={this.state.fields["last_name"]}/>
									{errors.last_name && <div className="text-danger">{errors.last_name}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="company" className="form-label">Company Name:</label>
									<input type="text" className="form-control" name="company" placeholder="Company" ref="company" id="company" onChange={this.handleChange.bind(this, "company")} defaultValue={this.state.fields["company"]} 
									    readOnly={isCompanyReadOnly}
									/>
									{errors.company && <div className="text-danger">{errors.company}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="address" className="form-label">Address:</label>
									<input type="text" className="form-control" name="address" placeholder="Address" ref="address" id="address" onChange={this.handleChange.bind(this, "address")} defaultValue={this.state.fields["address"]}/>
									{errors.address && <div className="text-danger">{errors.address}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="city" className="form-label">City:</label>
									<input type="text" className="form-control" name="city" placeholder="City" ref="city" id="city" onChange={this.handleChange.bind(this, "city")} defaultValue={this.state.fields["city"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="state" className="form-label">State</label>
									<input type="text" className="form-control" name="state" placeholder="State" ref="state" id="state" onChange={this.handleChange.bind(this, "state")} defaultValue={this.state.fields["state"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="zip" className="form-label">Zip</label>
									<input type="text" className="form-control" name="zip" placeholder="Zip" ref="zip" id="zip" onChange={this.handleChange.bind(this, "zip")} defaultValue={this.state.fields["zip"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="phone-number" className="form-label">Phone Number:</label>
									<input type="text" className="form-control" name="phone" placeholder="Phone Number" ref="phone" id="phone" onChange={this.handleChange.bind(this, "phone")} defaultValue={this.state.fields["phone"]}/>
									{errors.phone && <div className="text-danger">{errors.phone}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="cell-phone-number" className="form-label">Cell Phone Number:</label>
									<input type="text" className="form-control" name="cell_phone" placeholder="Cell Phone Number" ref="cell_phone" id="cell_phone" onChange={this.handleChange.bind(this, "cell_phone")} defaultValue={this.state.fields["cell_phone"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="direct_phone" className="form-label">Direct Phone Number:</label>
									<input type="text" className="form-control" name="direct_phone" placeholder="Direct Phone Number" ref="direct_phone" id="direct_phone" onChange={this.handleChange.bind(this, "direct_phone")} defaultValue={this.state.fields["direct_phone"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="fax" className="form-label">Fax Phone Number:</label>
									<input type="text" className="form-control" name="fax" placeholder="Fax" ref="fax" id="fax" onChange={this.handleChange.bind(this, "fax")} defaultValue={this.state.fields["fax"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="email" className="form-label">E-mail:</label>
									<input type="email" className="form-control" name="email" placeholder="E-mail" ref="email" id="email" onChange={this.handleChange.bind(this, "email")} defaultValue={this.state.fields["email"]} 
										readOnly={isEmailReadOnly}
									/>
									{errors.email && <span className="text-danger">{errors.email}</span>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="password" className="form-label">Password:</label>
									<input type="password" className="form-control" name="password" placeholder="Password" ref="encrypted_password" id="encrypted_password" onChange={this.handleChange.bind(this, "encrypted_password")} defaultValue={this.state.fields["encrypted_password"]}/>
									{errors.password && <div className="text-danger">{errors.password}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="password-confirmation" className="form-label">Password Confirmation</label>
									<input type="password" className="form-control" name="confirm_password" placeholder="Password Confirmation" ref="confirm_password" id="confirm_password" onChange={this.handleChange.bind(this, "conf_password")} defaultValue={this.state.fields["conf_password"]}/>
									{errors.confirm_password && <div className="text-danger">{errors.confirm_password}</div>}
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">	
								<div className="form-check">
									<input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
									<label className="form-check-label" htmlFor="flexCheckChecked">
										Subscribe to Newsletter
									</label>
								</div>
								<p className="m-0 text-center"><Link to={"/support"} target="_blank" >Contact Support</Link></p>
							</div>	
							<div className="col-md-12">
								<button type="submit" className="next-step" id="btnSignUp">
									<img src={continueBtn} className="img-fluid" alt="Continue"/>
								</button>
							</div>
						</div>		
					</div>
				</div>	
			</React.Fragment>
		)
	}

	renderAssociatSignupForm() {
		let { currentStep, fields, errors, company_logo, is_show_upload, isEmailReadOnly, isCompanyReadOnly, is_show_company_logo } = this.state;
		return(
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">	
						<div className="row">
							<div className="col-md-12 align-self-center">
								<p>In order to create your account please provide the information below</p>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="first_name" className="form-label">First Name:</label>
									<input type="text" className="form-control" name="first_name" placeholder="First Name" ref="first_name" id="first_name" onChange={this.handleChange.bind(this, "first_name")} defaultValue={this.state.fields["first_name"]}/>
									{errors.first_name && <div className="text-danger">{errors.first_name}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="middle_initial" className="form-label">Middle Name:</label>
									<input type="text" className="form-control" name="middle_initial" placeholder="Middle Name" id="middle_initial" ref="middle_initial" onChange={this.handleChange.bind(this, "middle_initial")} defaultValue={this.state.fields["middle_initial"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="last_name" className="form-label">Last Name:</label>
									<input type="text" className="form-control" name="last_name" placeholder="Last Name" ref="last_name" id="last_name" onChange={this.handleChange.bind(this, "last_name")} defaultValue={this.state.fields["last_name"]}/>
									{errors.last_name && <div className="text-danger">{errors.last_name}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="company" className="form-label">Company Name:</label>
									<input type="text" className="form-control" name="company" placeholder="Company" ref="company" id="company" onChange={this.handleChange.bind(this, "company")} defaultValue={this.state.fields["company"]}
										readOnly={isCompanyReadOnly}
									/>
									{errors.company && <div className="text-danger">{errors.company}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="address" className="form-label">Address:</label>
									<input type="text" className="form-control" name="address" placeholder="Address" ref="address" id="address" onChange={this.handleChange.bind(this, "address")} defaultValue={this.state.fields["address"]}/>
									{errors.address && <div className="text-danger">{errors.address}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="city" className="form-label">City:</label>
									<input type="text" className="form-control" name="city" placeholder="City" ref="city" id="city" onChange={this.handleChange.bind(this, "city")} defaultValue={this.state.fields["city"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="state" className="form-label">State</label>
									<input type="text" className="form-control" name="state" placeholder="State" ref="state" id="state" onChange={this.handleChange.bind(this, "state")} defaultValue={this.state.fields["state"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="zip" className="form-label">Zip</label>
									<input type="text" className="form-control" name="zip" placeholder="Zip" ref="zip" id="zip" onChange={this.handleChange.bind(this, "zip")} defaultValue={this.state.fields["zip"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="phone" className="form-label">Phone Number:</label>
									<input type="text" className="form-control" name="phone" placeholder="Phone Number" ref="phone" id="phone" onChange={this.handleChange.bind(this, "phone")} defaultValue={this.state.fields["phone"]}/>
									{errors.phone && <div className="text-danger">{errors.phone}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="cell_phone" className="form-label">Cell Phone Number:</label>
									<input type="text" className="form-control" name="cell_phone" placeholder="Cell Phone Number" ref="cell_phone" id="cell_phone" onChange={this.handleChange.bind(this, "cell_phone")} defaultValue={this.state.fields["cell_phone"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="direct_phone" className="form-label">Direct Phone Number:</label>
									<input type="text" className="form-control" name="direct_phone" placeholder="Direct Phone Number" ref="direct_phone" id="direct_phone" onChange={this.handleChange.bind(this, "direct_phone")} defaultValue={this.state.fields["direct_phone"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="fax" className="form-label">Fax Phone Number:</label>
									<input type="text" className="form-control" name="fax" placeholder="Fax" ref="fax" id="fax" onChange={this.handleChange.bind(this, "fax")} defaultValue={this.state.fields["fax"]}/>
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="email" className="form-label">E-mail:</label>
									<input type="email" className="form-control" name="email" placeholder="E-mail" ref="email" id="email" onChange={this.handleChange.bind(this, "email")} defaultValue={this.state.fields["email"]}
										readOnly={isEmailReadOnly}
									/>
									{errors.email && <span className="text-danger">{errors.email}</span>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="password" className="form-label">Password:</label>
									<input type="password" className="form-control" name="password" placeholder="Password" ref="encrypted_password" id="encrypted_password" onChange={this.handleChange.bind(this, "encrypted_password")} defaultValue={this.state.fields["encrypted_password"]}/>
									{errors.password && <div className="text-danger">{errors.password}</div>}
								</div>
							</div>
							<div className="col-md-3">
								<div className="mb-3">
									<label htmlFor="password-confirmation" className="form-label">Password Confirmation</label>
									<input type="password" className="form-control" name="confirm_password" placeholder="Password Confirmation" ref="confirm_password" id="confirm_password" onChange={this.handleChange.bind(this, "conf_password")} defaultValue={this.state.fields["conf_password"]}/>
									{errors.confirm_password && <div className="text-danger">{errors.confirm_password}</div>}
								</div>
							</div>
							{is_show_company_logo && (
								<React.Fragment>
									<div className="col-md-3">
										<div className="mb-3">
											<div className="upload-logo">
												<img src={company_logo} className="img-fluid d-block mx-auto" alt="Upload Logo" />
												<input type="file" id="company_logo" className="d-none" onChange={this.handleLogoChange.bind(this)} accept="image/*"/>
											</div>
											{is_show_upload && (
												<React.Fragment>
													<div className="upload-btn text-center mt-2">
														<button type="button" className="upload-logo-btn" onClick={() => document.getElementById('company_logo').click()}>Upload Logo</button> <small>(Optional)</small>
													</div>
												</React.Fragment>
											)}
										</div>
									</div>
								</React.Fragment>
							)}
						</div>
						<div className="row">
							<div className="col-md-12">	
								<div className="form-check">
									<input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked />
									<label className="form-check-label" htmlFor="flexCheckChecked">
										Subscribe to Newsletter
									</label>
								</div>
								<p className="m-0 text-center"><a href="">Contact Support</a></p>
							</div>	
							<div className="col-md-12">
								<button type="submit" className="next-step">
									<img src={continueBtn} className="img-fluid" alt="Continue"/>
								</button>
							</div>
						</div>		
					</div>
				</div>
			</React.Fragment>
		)
	}
	
	renderStep2Html() {
		let { currentStep, fields, errors } = this.state;
		return(
			<React.Fragment>
				{this.renderAssociatSignupForm()}
			</React.Fragment>
		)
	}

	renderStep3Html() {
		return(
			<React.Fragment>
				<div className="row">
					<div className="col-md-12">	
						<img src={logo} className="img-fluid d-block mx-auto center-logo" alt="Techtop" />
						<div className="thank-you-txt-img">
							<img src={thankYouImg} className="img-fluid d-block mx-auto" alt="Techtop" />
						</div>	
						<p className="m-0"><strong>Thank you for signing up!</strong></p> 
						<p className="m-0"><strong>Your account is being validated and will be accessible soon. Please check your email for updates on your account status</strong></p>
						<a href="/" className="back-btn">Back to Home Page</a>
						
					</div>
				</div>	
			</React.Fragment>
		)
	}

	renderStepContent() {
		let { currentStep } = this.state;
		return(
			<React.Fragment>
				<div className={`step step-${currentStep} ${(currentStep === 3) && 'text-center'}`}>
					{this[`renderStep${currentStep}Html`]()}
				</div>
			</React.Fragment>
		)
	}

	renderSignupError() {
		const { signup_error_message } = this.state;
		return(
			<React.Fragment>
				{(signup_error_message) && 
					(
						<React.Fragment>
							<div className="alert alert-danger text-center mt-2" role="alert">
								<h4 className="alert-heading fw-bold"> Error !</h4>
								<p>{ signup_error_message }</p>
							</div>
						</React.Fragment>
					)
				}
			</React.Fragment>
		) 
	}

	renderHtmlContent() {
		const { user_data, invitation_token, isSpin } = this.state;
		if (isSpin) {
	        return <GearSpinner />;
	    }
		return(
			<React.Fragment>
				{(invitation_token !== '' && Object.keys(user_data).length === 0) ?
					<React.Fragment>
						<div className="text-center">
							<h1>Invalid Invitation Token</h1>
						</div>
					</React.Fragment>
					:
					<React.Fragment>
						<form onSubmit={this.handleSubmit.bind(this)} id="techtop-multi-step-form">
							{this.renderStepContent()}
						</form>
					</React.Fragment> 
					
				}
			</React.Fragment>
		)
	}

	renderFormHtml() {
		return(
			<React.Fragment>
				<form onSubmit={this.handleSubmit.bind(this)} id="techtop-multi-step-form">
					{this.renderStepContent()}
				</form>	
			</React.Fragment>
		)
	}

	render() {
		let { fields, currentStep, isLoading } = this.state;
		const user_id = localStorage.getItem('techtop_user_id');
		if (user_id) {
	      return <Redirect to="/" />;
	    }
		return(
			<React.Fragment>
				<main className="techtop-middle-div">
					<section className={(fields.user_role === 'associate' && currentStep === 2) ? 'techtop-sign-up-associate-section py-5' : 'techtop-sign-up-section py-5' }>
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<Loader isLoading={isLoading} message="Processing..."/>
									<div className="default-title">
										<h1>
									    {currentStep === 1 && 'Sign up - Your Role'}
									    {fields.user_role === 'associate' && currentStep === 2 && 'Sign up - Associate - Personal & Account Details'}
									    {fields.user_role === 'admin' && currentStep === 2 && 'Sign up - Admin - Personal & Account Details'}
									    {fields.user_role === 'associate' && currentStep === 3 && "Sign up - Associate - You're All Set!"}
									    {fields.user_role === 'admin' && currentStep === 3 && "Sign up - Admin - You're All Set!"}
									  </h1>
									</div>
									<div id="ip-sign-up-form">
										{this.renderProgressHtml()}
										<div className="row">
											<div className="col-md-12">
												{this.renderHtmlContent()}
											</div>
										</div>	
									</div>
								</div>
							</div>
						</div>
					</section>
				</main>
			</React.Fragment>
		)
	}
}
export default SignUp